import { useState, useEffect } from 'react'
import { PreviewColumn } from './PreviewColumn'
import { EditorColumn } from './EditorColumn'
import ColumnHeader from './ColumnHeader'
import { TAB } from '../utils/constants'
import Tabs from './Tabs'
import useDeviceDetect from '../../hooks/useDeviceDetect'
import { FaSave } from 'react-icons/fa'
import { toast } from 'react-toastify'
import { API_URL } from '../../creds'


const EditPreviewContainer = ({
  templates,
  setTemplates,
  getTemplate,
  focusedSectionSlug,
  selectedSectionSlugs,
  setSelectedSectionSlugs,
  projectId,
  language,
}) => {
  const [selectedTab, setSelectedTab] = useState(TAB.PREVIEW)
  const [saving, setSaving] = useState(false);
  const [markdown, setMarkdown] = useState("")
  const { isMobile } = useDeviceDetect()

  console.log("language::", language)

  useEffect(() => {
    setSelectedTab(isMobile ? TAB.EDITOR : TAB.PREVIEW)
  }, [isMobile])

  const showEditorColumn = !isMobile || selectedTab === TAB.EDITOR
  const showPreviewColumn =
    !isMobile || selectedTab === TAB.PREVIEW || selectedTab === TAB.RAW

  const handleSave = async () => {
    if (!projectId) {
      toast.error('No project selected to save.');
      return;
    }

    if (!localStorage.getItem('access_token')) {
      toast.error('You are not logged in.');
      return;
    }

    setSaving(true);

    const toastId = toast.loading('Saving project...');

    try {
      const response = await fetch(`${API_URL}/projects/${projectId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
        },
        body: JSON.stringify({ content: markdown }),
      });

      if (!response.ok) {
        const err = await response.json();
        throw new Error(err.detail || 'Save failed');
      }

      toast.success('Project saved successfully!', { id: toastId });
      setSelectedSectionSlugs([])

    } catch (error) {
      toast.error(error.message || 'Failed to save project', { id: toastId });
    } finally {
      toast.dismiss(toastId);
      setSaving(false);
    }
  };

  return (
    <div className="flex pt-6 px-6 md:p-0 flex-col md:flex-row items-center justify-center">
      {isMobile && (
        <Tabs
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          focusedSectionSlug={focusedSectionSlug}
        />
      )}

      {showEditorColumn && (
        <div className="w-full px-3 full-screen">
          {!isMobile && (
            <ColumnHeader.Heading>
              Editor
            </ColumnHeader.Heading>
          )}

          <EditorColumn
            focusedSectionSlug={focusedSectionSlug}
            selectedSectionSlugs={selectedSectionSlugs}
            setSelectedSectionSlugs={setSelectedSectionSlugs}
            templates={templates}
            setTemplates={setTemplates}
            theme="light"
            language={language}
          />
        </div>
      )}

      {showPreviewColumn && (
        <div className="px-3 flex-1">
          {!isMobile && (
            <div className="border-b border-gray-200">
              <nav className="flex space-x-8">
                <ColumnHeader.Tab
                  isActive={selectedTab === TAB.PREVIEW}
                  className="pb-3"
                  onClick={() => setSelectedTab(TAB.PREVIEW)}
                >
                  Preview
                </ColumnHeader.Tab>

                <ColumnHeader.Tab
                  isActive={selectedTab === TAB.RAW}
                  className="pb-3"
                  onClick={() => setSelectedTab(TAB.RAW)}
                >
                  Raw
                </ColumnHeader.Tab>

              </nav>
              <button
                onClick={handleSave}
                // disabled={saving}
                className={`
                          absolute top-20 right-20 z-10
                          flex items-center gap-2 px-6 py-2 -m-1
                          rounded-lg font-medium text-xl
                          transition-all
                          ${saving
                    ? 'bg-gray-400 cursor-not-allowed text-gray-200'
                    : 'bg-blue-600 hover:bg-blue-700 text-white shadow-md hover:shadow-lg'
                  }
                          focus:outline-none focus:ring-2 focus:ring-blue-500
                        `}
                title="Save project"
              >
                <FaSave size={16} />
                {saving ? 'Saving...' : 'Save'}
              </button>
            </div>
          )}

          <PreviewColumn
            selectedSectionSlugs={selectedSectionSlugs}
            getTemplate={getTemplate}
            selectedTab={selectedTab}
            setMarkdown={setMarkdown}
            language={language}
          />
        </div>
      )
      }
    </div >
  )
}

export default EditPreviewContainer
